var map = {
  "./activate_site": "78089",
  "./activate_site.js": "78089",
  "./disable_site": "88116",
  "./disable_site.js": "88116",
  "./index_organization_active_sites": "68178",
  "./index_organization_active_sites.js": "68178",
  "./index_organization_disabled_sites": "4080",
  "./index_organization_disabled_sites.js": "4080",
  "./index_organization_new_sites": "66566",
  "./index_organization_new_sites.js": "66566"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 23712;
